import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { Endereco } from '../modelo/endereco';
import { SelectItem } from '../modelo/selectItem';
import { Estado } from '../enumaration/estado';
import { RestClientService } from '../services/restclient.service';
import { MensagemService } from '../services/mensagem.service';
import { EnderecoService } from '../services/endereco.service';
import { Cep } from '../modelo/cep';
import { MatDialog } from '@angular/material';
import { EnderecoModalConfirmarComponent } from './endereco-modal-confirmar.component';
import { Contrato } from '../modelo/contrato';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Config } from '../services/config';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnderecoLogradouro } from '../modelo/enderecoLogradouro';
import { EnderecoModalBuscaComponent } from './endereco-modal-busca.component';
import { EnderecoCep } from '../modelo/enderecoCep';

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'app-endereco-dados',
  templateUrl: './endereco-dados.component.html',
  styleUrls: ['./endereco.component.css'],
  providers: [EnderecoService, MensagemService, RestClientService]
})
export class EnderecoDadosComponent extends AbstractComponent implements OnInit {

  contrato: Contrato = new Contrato();
  endereco: Endereco = new Endereco();
  enderecoAtual: Endereco = new Endereco();
  estadoList: SelectItem[];
  veioSegundaViaCarne: string = 'N';
  dataNascimento: Date | undefined;

  dsEnderecoIsActive: boolean = true;
  nuEnderecoIsActive: boolean = true;
  dsComplementoIsActive: boolean = true;
  dsBairroIsActive: boolean = true;
  cdUfIsActive: boolean = true;
  dsCidadeIsActive: boolean = true;

  constructor(
    private sessaoService: SessaoService,
    private enderecoService: EnderecoService,
    private mensagemService: MensagemService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    public dialog: MatDialog) {
    super(sessaoService);

    // Cria combo de estado
    this.estadoList = Estado.values();
  }

  /**
   * Método chamado na inicialização
   */
  ngOnInit() {

    //Initializate inputs as readOnly
    this.readonly = true;

    // Forms Action
    $('.modal').modal();

    //Scroll top
    window.scrollTo(0, 0);

    // Limpa as mensagens de erro ao entrar na tela
    this.mensagemService.clear();

    const contratoData = sessionStorage.getItem('contrato');
    this.contrato = contratoData ? JSON.parse(contratoData) : new Contrato();
    this.veioSegundaViaCarne = sessionStorage.getItem('veioSegundaViaCarne') || 'N';

    this.buscaEndereco(this.contrato);

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function () {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  /**
   * Realiza a busca de endereço
   * @param contrato
   */
  buscaEndereco = (contrato: Contrato): void => {
    this.enderecoService.recuperarEndereco(contrato).subscribe(
      (result: Contrato) => {
        if (result.cdMsgemRetorno == "0") {
          this.endereco = result.endereco;
          this.enderecoAtual = JSON.parse(JSON.stringify(result.endereco));
        }
        else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Realiza a busca do endereço pelo cep informado.
   * Se não encontrar abre a popup para busca do endereço
   */
  modalBusca() {
    if (!this.validacaoCep()) {
      this.mensagemService.show(this.campos);
      return;
    }
    this.enderecoService.consultarEndereco(this.endereco.cdCep).subscribe(
      (result: Cep) => {

        if (result.cdMsgemRetorno == 0) {
          this.limpaCampos();
          this.dsEnderecoIsActive = true;
          this.nuEnderecoIsActive = true;
          this.dsComplementoIsActive = true;
          this.dsBairroIsActive = true;
          this.cdUfIsActive = true;
          this.dsCidadeIsActive = true;

          this.endereco.dsEndereco = result.listaEndereco[0].nmTpEndereco.trim() + " " + result.listaEndereco[0].nmEndereco;
          this.endereco.dsBairro = result.listaEndereco[0].nmBairro;
          this.endereco.dsCidade = result.listaEndereco[0].nmCidade;
          this.endereco.cdUf = result.listaEndereco[0].nmUF;

          if (!this.endereco.dsEndereco.trim()) {
            this.dsEnderecoIsActive = false;
            this.endereco.nuEndereco = 0;
          }
          if (this.endereco.nuEndereco == 0) {
            this.nuEnderecoIsActive = false;
          }
          if (!this.endereco.dsComplemento.trim()) {
            this.dsComplementoIsActive = false;
          }
          if (!this.endereco.dsBairro.trim()) {
            this.dsBairroIsActive = false;
          }
          if (!this.endereco.cdUf.trim()) {
            this.cdUfIsActive = false;
          }
          if (!this.endereco.dsCidade.trim()) {
            this.dsCidadeIsActive = false;
          }

          if (this.endereco.dsEndereco.trim() == "")
            this.modalPesquisa();
        }
        else {
          // abre a modal de pesquisa
          this.modalPesquisa();
          this.readonly = false;
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  /**
   * Abre a modal de confirmação
   * @param endereco 
   * @param enderecoAtual 
   */
  modalSolicitar(endereco: Endereco, enderecoAtual: Endereco): void {
    if (!this.validacaoBasica()) {
      this.mensagemService.show(this.campos);
      return;
    }
    this.dialog.open(EnderecoModalConfirmarComponent, {
      width: Config.POPUP_100VW,
      height: Config.POPUP_65PERCENT,
      data: {
        enderecoAtual: enderecoAtual,
        enderecoNovo: endereco,
        contrato: this.contrato
      }
    });
  }

  /**
   * Abre a modal de pesquisa
   * @param endereco 
   * @param enderecoAtual 
   */
  modalPesquisa() {
    let dialogRef = this.dialog.open(EnderecoModalBuscaComponent, {
      width: Config.POPUP_100VW,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var enderecoCep: EnderecoCep = result;
        this.endereco.cdCep = enderecoCep.nuCep.trim() + "-" + enderecoCep.nuComplementoCep;
        this.endereco.dsEndereco = enderecoCep.nmTpEndereco.trim() + " " + enderecoCep.nmEndereco;
        this.endereco.dsBairro = enderecoCep.nmBairro;
        this.endereco.cdUf = enderecoCep.nmUF;
        this.endereco.dsCidade = enderecoCep.nmCidade;
      }
    });
  }

  /**
   * Validação Básica da tela
   */
  validacaoBasica = (): boolean => {
    this.mensagemService.clear();
    this.campos = [];
    var isValid = true;
    if (!this.endereco.nuEndereco || this.endereco.nuEndereco == 0) {
      this.campos.push("numero");
      isValid = false;
    }
    if (!this.endereco.cdCep || this.endereco.cdCep.trim() == "") {
      this.campos.push("cep");
      isValid = false;
    }
    if (!this.endereco.dsEndereco || this.endereco.dsEndereco.trim() == "") {
      this.campos.push("endereco");
      isValid = false;
    }
    if (!this.endereco.dsBairro || this.endereco.dsBairro.trim() == "") {
      this.campos.push("bairro");
      isValid = false;
    }
    if (!this.endereco.cdUf || this.endereco.cdUf.trim() == "") {
      this.campos.push("estado");
      isValid = false;
    }
    if (!this.endereco.dsCidade || this.endereco.dsCidade.trim() == "") {
      this.campos.push("cidade");
      isValid = false;
    }

    return isValid;
  }

  /**
   * Validação do Cep
   */
  validacaoCep = (): boolean => {
    this.mensagemService.clear();
    this.campos = [];
    var isValid = true;
    if (!this.endereco.cdCep || this.endereco.cdCep.trim() == "") {
      this.campos.push("cep");
      isValid = false;
    }

    return isValid;
  }

  /**
   * Retorna para a tela que chamou
   */
  voltar(): void {
    if (this.veioSegundaViaCarne == 'N') {
      this.router.navigate(['/BF-Portal/endereco']);
    } else {
      sessionStorage.setItem('segundaViaContrato', JSON.stringify(this.contrato));
      this.router.navigate(['/BF-Portal/segundaviacarneEndereco']);
    }
  }

  /**
   * Função para limpar os campos da tela
   */
  limpaCampos(): void {
    this.endereco.dsEndereco = "";
    this.endereco.nuEndereco = 0;
    this.endereco.dsComplemento = "";
    this.endereco.dsBairro = "";
    this.endereco.dsCidade = "";
    this.endereco.cdUf = "";
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-endereco-cli/endereco-dados.component.ts